/**
 * Copyright (C) Techniserv, spol. s r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import ErrorAlert from '../feedbackResponseAlerts/ErrorAlert.js';
import SuccessAlert from '../feedbackResponseAlerts/SuccessAlert.js';

export default function({dislikeReason, comment, endpoint, namespace}) {
  var data = new FormData()
  data.append(`${namespace}dislikeReason`, dislikeReason)
  data.append(`${namespace}comment`, comment)

  const rootElement = document.getElementById(`${namespace}articleFeedback`)
  const articleFeedbackForm = document.getElementById(`${namespace}article_feedback_form`)

  return Liferay.Util.fetch(endpoint, {
    headers: {
      'Accept': 'application/json'
    },
    method: 'POST',
    body: data
  }).then(function(response) {
    rootElement.removeChild(articleFeedbackForm)
    if (response.status == 202) {
      rootElement.append(SuccessAlert())
    } else if (response.status == 422) {
      console.log(response.json())
      rootElement.append(ErrorAlert(Liferay.Language.get('articlefeedback.error.invalidInput')))
    } else {
      console.log(response.json())
      rootElement.append(ErrorAlert())
    }
  }).catch((error) => {
    console.log(error)
    rootElement.removeChild(articleFeedbackForm)
    rootElement.append(ErrorAlert())
  })
}
